import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import lurneaxIcon from "@/assets/lurneax-logo-icon.svg";

const GREETINGS = [
  { text: "Hello", gen: "Classic" },
  { text: "Hey there!", gen: "Millennials" },
  { text: "Yo!", gen: "Gen X" },
  { text: "What's up!", gen: "Gen Y" },
  { text: "Slay!", gen: "Gen Z" },
  { text: "No cap, welcome!", gen: "Gen Z" },
  { text: "It's giving... login", gen: "Gen Z" },
  { text: "Skibidi hello!", gen: "Gen Alpha" },
  { text: "Rizz check! ✨", gen: "Gen Alpha" },
  { text: "You're so sigma!", gen: "Gen Alpha" },
  { text: "Based welcome!", gen: "Gen Z" },
  { text: "Bussin' entrance!", gen: "Gen Z" },
  { text: "Let's gooo!", gen: "Millennials" },
  { text: "Vibes only 💫", gen: "Gen Z" },
];

interface AnimatedGreetingOverlayProps {
  isVisible: boolean;
  userName?: string;
}

export function AnimatedGreetingOverlay({
  isVisible,
  userName,
}: AnimatedGreetingOverlayProps) {
  const [greetingIndex, setGreetingIndex] = useState(0);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!isVisible) {
      setGreetingIndex(0);
      setIsExiting(false);
      return;
    }

    const interval = setInterval(() => {
      setGreetingIndex((prev) => (prev + 1) % GREETINGS.length);
    }, 500);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  const currentGreeting = GREETINGS[greetingIndex];

  return (
    <div
      className={cn(
        "fixed inset-0 z-[9999] bg-background/98 backdrop-blur-md flex flex-col items-center justify-center transition-opacity duration-300",
        isExiting ? "opacity-0" : "opacity-100"
      )}
    >
      {/* Logo icon */}
      <img
        src={lurneaxIcon}
        alt="Lurneax"
        className="h-16 md:h-20 mb-8 animate-pulse"
      />

      {/* Main greeting container */}
      <div className="text-center space-y-4">
        {/* Animated greeting */}
        <div className="relative h-24 md:h-32 flex items-center justify-center overflow-hidden">
          <h1
            key={greetingIndex}
            className="text-5xl md:text-7xl lg:text-8xl font-bold bg-gradient-to-r from-primary via-primary/80 to-primary bg-clip-text text-transparent animate-fade-in"
          >
            {currentGreeting.text}
          </h1>
        </div>

        {/* User name or generic text */}
        <p className="text-xl md:text-2xl text-muted-foreground font-medium">
          {userName ? userName : "Signing you in"}
        </p>

        {/* Generation indicator */}
        <p className="text-sm text-muted-foreground/60 italic">
          {currentGreeting.gen}
        </p>

        {/* Loading dots */}
        <div className="flex items-center justify-center gap-2 mt-8">
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:-0.3s]" />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:-0.15s]" />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce" />
        </div>
      </div>
    </div>
  );
}
